import React, { useState, useEffect } from "react";
import { Button } from "@public/ui-toolkit";
import ReactModal from "@public/ui-toolkit/src/ReactModal";
import timezones from "./timezon.json";
import moment from "moment";
import Select from "react-select";
import { useHistory } from "react-router";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #212529",
    padding: 4,
  }),
  option: (base, state) => ({
    ...base,
    height: "100%",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#000",
  }),
  singleValue: (provided) => ({ ...provided, color: "#000" }),
  input: (styles) => ({ ...styles, color: "#000" }),
};

const ScheduleModal = ({
  fundManagers = [],
  name = "",
  hedgeFundId,
  getSlots,
  freeSlots = [],
  users = [],
  newAppointment,
  loading,
  title,
  admin,
  Visible,
  setVisibility,
}) => {
  const [modalForm, setModalForm] = useState({
    durationHour: 0,
    durationMint: 30,
  });
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [startTime, setStartTime] = useState("12:00");
  const [description, setDescription] = useState("");
  const [fcnName, setFCNName] = useState("");
  const [topic, setTopic] = useState("");
  const [timezone, setTimezome] = useState("");
  const [timezoneValue, setTimezomeValue] = useState("");

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [managerName, setManagerName] = useState("");

  const onCloseModal = () => setVisibility(false);
  const history = useHistory();
  const durationOption = [
    { value: 0, label: 0 },
    { value: 15, label: 15 },
    { value: 30, label: 30 },
    { value: 45, label: 45 },
  ];
  const durationHourOption = [
    { value: 0, label: 0 },
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
    { value: 6, label: 6 },
  ];
  
  useEffect(() => {
    const currentDate = new Date();
    const currentOffset = -currentDate.getTimezoneOffset()/60;
    var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var time = timezones.find((timeZone) => timeZone.utc.includes(currentTimezone) && timeZone.offset === currentOffset);
    if(time){
      setTimezome({ value: time.value, label: time.text + " " + time.value });
      setTimezomeValue(time.value);
    }else{
      setTimezome({ value: 'Eastern Standard Time', label: '(UTC-05:00) Eastern Time (US & Canada)' + " " + "Eastern Standard Time"})
      setTimezomeValue('Eastern Standard Time');
    }
  }, []);

  const onSuccess = (appointmentId) => {
    setSelectedUsers([]);
    setTimezome("");
    setTimezomeValue("");
    setTopic("");
    setModalForm({
      durationHour: 1,
      durationMint: 0,
    });
    setDescription("");
    if (appointmentId > 0) {
      history.push(`/meeting?appointmentId=${appointmentId}`);
    }
    onCloseModal();
  };
  const onFinish = () => {
    var startDateTime = startDate + "T" + startTime;
    var endTime = new Date(startDateTime);
    endTime.setMinutes(endTime.getMinutes() + modalForm.durationMint);
    endTime.setHours(endTime.getHours() + modalForm.durationHour);
    var endDateTime = moment(endTime).format("yyyy-MM-DDTHH:mm");
    var data = selectedUsers?.map((item) => {
      return { userAttendeeId: item.value, type: 0 };
    });
    var data1 = data.concat(
      fcnName.length > 0
        ? fcnName?.map((item) => {
            return { userAttendeeId: item.value, type: 2 };
          })
        : []
    );
    var usersList = data1.concat(
      managerName.length > 0
        ? managerName?.map((item) => {
            return { userAttendeeId: item.value, type: 1 };
          })
        : []
    );
    const payload = {
      hedgefundId: hedgeFundId,
      // fundId: parseInt(fundId),
      startTime: startDateTime,
      endTime: endDateTime,
      allocatorUsers: usersList,
      description: description,
      topic: topic,
      startLocalTime: startDateTime,
      timezoneValue: timezoneValue,
    };
    newAppointment(payload, onSuccess);
  };
  return (
    <>
      {Visible && (
        <ReactModal
          open={Visible}
          onClose={onCloseModal}
          modalSize="900px"
          center
          title={title}
        >
          <div className="row  mt-0 mb-5" >
            <div className="col-md-6 pe-3">
              <div className="pt-2">
                <label className="pb-1">Topic</label>
                <input
                  value={topic}
                  type="text"
                  placeholder="Topic"
                  className="form-control border-dark"
                  onChange={(e) => {
                    setTopic(e.target.value);
                  }}
                />
              </div>
              <div className="pt-2">
                <div className="dropdown">
                  <label className="pb-1">
                    Select <b>{name} </b> Team Member
                  </label>
                  <Select
                    styles={customStyles}
                    onChange={(e) => setManagerName(e)}
                    options={fundManagers.map(({ title, fullName, id }) => {
                      return {
                        value: id,
                        label: fullName + " " + `(${title === null ? title : "N/A"})`,
                      };
                    })}
                    isMulti
                  />
                </div>
              </div>
              <div className="pt-2">
                <label className="pb-1">
                  Add Members of your Team (optional)
                </label>
                <Select
                  styles={customStyles}
                  onChange={(e) => {
                    setSelectedUsers(e);
                  }}
                  options={users.map(({ name, id }) => {
                    return { value: id, label: name };
                  })}
                  isMulti
                />
              </div>

              <div className="pt-2">
                <div className="dropdown">
                  <label className="pb-1">Add FCN Member (optional)</label>
                  <Select
                    styles={customStyles}
                    onChange={(e) => setFCNName(e)}
                    options={admin.map(({ name, id }) => {
                      return { value: id, label: name };
                    })}
                    isMulti
                  />
                </div>
              </div>
              <div className="pt-2">
                <label className="pb-1">Add Description</label>
                <textarea
                  value={description}
                  placeholder="Description"
                  className="form-control rounded border-dark p-3"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>

            <div className="col-md-6 ps-3 mt-3">
              <div className="card mb-3" style={{ backgroundColor: "#0e345a" }}>
                <div className="card-header text-white">
                  Select Meeting Time
                </div>
                <div className="card-body">
                  <div className="col-md-12">
                    <label className="text-white">Time Zone</label>
                    <Select
                      styles={customStyles}
                      value={timezone ? timezone : ""}
                      onChange={(e) => {
                        var time = e.value.replace("|", " ");
                        setTimezome({ value: time, label: time });
                        var zoneValue = e.value.split("|");
                        setTimezomeValue(zoneValue[1]);
                      }}
                      options={timezones.map((item) => {
                        const timezone = {
                          value: item.text + "|" + item.value,
                          label: item.text + " " + item.value,
                        };
                        return timezone;
                      })}
                    />
                  </div>
                  <div className="row ">
                    <label className="text-white">When</label>

                    <div className="col-md-7 p-2">
                      <label className="text-white">Date</label>
                      <input
                        value={startDate}
                        type="date"
                        className="form-control"
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-5 p-2">
                      <label className="text-white">Time</label>
                      <input
                        value={startTime}
                        type="time"
                        className="form-control"
                        onChange={(e) => setStartTime(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <span className="text-white">Duration</span>

                    <div className="col-md-6 p-2">
                      <label className="text-white">Hour</label>
                      <select
                        className="form-select"
                        value={modalForm.durationHour}
                        onChange={(e) =>
                          setModalForm({
                            ...modalForm,
                            durationHour: parseInt(e.target.value),
                          })
                        }
                      >
                        {durationHourOption.map(({ label, value }, index) => (
                          <option key={index} value={value}>
                            {label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 p-2">
                      <label className="text-white">Mint</label>
                      <select
                        className="form-select"
                        value={modalForm.durationMint}
                        onChange={(e) =>
                          setModalForm({
                            ...modalForm,
                            durationMint: parseInt(e.target.value),
                          })
                        }
                      >
                        {durationOption.map(({ label, value }, index) => (
                          <option key={index} value={value}>
                            {label}
                          </option>
                        ))}
                      </select>
                    </div>
                    {(() => {
                      if (
                        (modalForm.durationHour || modalForm.durationMint) === 0
                      ) {
                        return (
                          <div style={{ color: "#ff6c6c" }}>
                            {"Duration should be greater than 0 min"}
                          </div>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Button
              btnName="Save"
              disabled={
                managerName &&
                (modalForm.durationMint || modalForm.durationHour !== 0)
                  ? false
                  : true
              }
              loading={loading}
              onClick={onFinish}
              btnType="primary"
            />
          </div>
        </ReactModal>
      )}{" "}
    </>
  );
};

export default ScheduleModal;
